import { ReactNode, useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import CategoryGroup from '../../components/common/CategoryGroup'
import Text from '../../components/common/Text'
import Button from '../../components/common/Button'
import Image from '../../components/common/Image'
import { useHistory } from 'react-router'
import * as paths from '../../constant/path'
import { useGetNews } from '../../services/digital-news/digital-news-query'
import { NewsType, NewsWithPaging } from '../../services/digital-news/digital-news-types'
import { useGetUser } from '../../services/user/user-query'
import config from '../../config'
import color from '../../constant/colors'
import { mobile } from '../../utils/responsive-helper'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

const NewsItemLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 40px;
  cursor: pointer;
  background-color: ${color.WHITE}; 
  border-radius: 8px;
  padding: 16px;

  .left {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    align-self: stretch;
  }

  .right {
    width: 176px;
    height: 100%;
    min-height: 120px;
    border-radius: 8px;
  }

  ${mobile} {
    flex-direction: column;
    row-gap: 16px;

    .left {    
      order: 2;
    }

    .right {
      width: 100%;
    }
  }
`
const NewsSubTitle = styled.div`
  display: flex;
  column-gap: 16px;
  align-items: center;

  .date {
    display: flex;
    column-gap: 8px;
    align-items: center;
  }
`

const News = () => {
  const history = useHistory()
  const { data: user } = useGetUser()
  const { userBudget } = user || {}
  const { userId } = userBudget || {}
  const { t, i18n } = useTranslation()

  const { data } = useGetNews({
    size: 3,
    userId: userId,
    category: 'all',
    subCategory: 'News',
  })

  const newsPath = useMemo(() => {
    return paths.news()
  }, [])

  const onNewsDetailClick = useCallback(
    (newsId: number) => {
      history.push(paths.newsDetails({ routeParam: { newsId } }))
    },
    [history],
  )

  return (
    <CategoryGroup
      label={t('home.activity')}
      path={newsPath}
      viewMoreText=" "
      contentStyle={{
        gridTemplateColumns: 'repeat(1, 1fr)',
      }}
      headerStyle={{
        marginBottom: 32
      }}
    >
      {data?.pages.map(({ data: page }: NewsWithPaging) =>
        page.map((news: NewsType) => (
          <NewsItemLayout key={news.digitalNews.id}
            onClick={() => {
              onNewsDetailClick(news.digitalNews.id)
            }}>
            <div className='left'>
              <Text size={16} type="Bold">{news.digitalNews.title}</Text>
              <NewsSubTitle>
                <div className='date'>
                  <Image imageName='calendarIcon' />
                  <Text size={10}>{dayjs(news.digitalNews.digitalNewsPublishDate).locale(i18n.language).format('DD MMM YYYY')}</Text>
                </div>
                <Button background={color.BACKGROUND} style={{
                  borderRadius: 16,
                  width: 'fit-content',
                  padding: '2px 10px',
                  height: 'fit-content',
                }}>
                  <Text size={14}>{news.digitalNews.digitalNewsType}</Text>
                </Button>
              </NewsSubTitle>
            </div>
            <Image
              className='right'
              src={news?.digitalNews?.thumbnailPath?.indexOf('http') > -1 ? news?.digitalNews?.thumbnailPath : `${config.apiHost}${news?.digitalNews?.thumbnailPath}`}
            />
          </NewsItemLayout>
        )),
      )}
    </CategoryGroup>
  )
}

export default News
